import { render, staticRenderFns } from "./FeedIndicador.vue?vue&type=template&id=e9479550&"
import script from "./FeedIndicador.vue?vue&type=script&lang=js&"
export * from "./FeedIndicador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports